/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import {
  getBraindateLocation,
  getBraindateId,
} from '@braindate/domain/lib/braindate/util';
import { isVirtualLocation } from '@braindate/domain/lib/location/util';
import styles from './CheckInTakeOver.style';
import messages from 'src/shared/app/check-in/l10n/checkInTakeOverL10n';
import UpcomingBraindateCard from 'src/shared/app/braindate/component/card/upcoming/UpcomingBraindateCard';
import TakeOver from 'src/shared/app/notification/component/TakeOver';
import Subheading from 'src/shared/ui/component/text/Subheading';
import CheckInTakeOverVirtualAction from './CheckInTakeOverVirtualAction';
import CheckInTakeOverOnsiteAction from './CheckInTakeOverOnsiteAction';
import ChatIcon from 'src/shared/ui/component/icon/ChatIcon';
import useVirtualBraindateOverlayShown from 'plugin/virtual-braindate/hook/useVirtualBraindateOverlayShown';

import type { Braindate } from '@braindate/domain/lib/braindate/type';
import { getJoinedBraindates } from 'src/shared/app/braindate/selector/joinedBraindateSelectors';

type Props = {
  braindate: Braindate,
  handleDismiss: () => void,
};

const useStyles = createUseThemeStyles(styles);

const CheckInTakeOverDumb = ({
  handleDismiss,
  braindate,
}: Props): React.Node => {
  const location = getBraindateLocation(braindate);
  const isVirtual = location && isVirtualLocation(location);

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */
  const isVirtualBraindateShown = useVirtualBraindateOverlayShown();

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | State
   |----------------------------------------------------------------------------
   */

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Refs
   |----------------------------------------------------------------------------
   */

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const joinedBraindates = useSelector(getJoinedBraindates);
  if (joinedBraindates.includes(getBraindateId(braindate))) return null;

  if (isVirtualBraindateShown) return null;

  return (
    <TakeOver handleDismiss={handleDismiss}>
      <div className={classes.root}>
        <div className={classes.top}>
          <div className={classes.icon}>
            <ChatIcon />
          </div>
          <Subheading layoutClass={classes.heading}>
            {intl.formatMessage(messages.takeOverTitle)}
          </Subheading>

          <div className={classes.card}>
            <UpcomingBraindateCard
              braindate={braindate}
              isInactive
              showCheckin={false}
            />
          </div>
        </div>
        <div className={classes.action}>
          {isVirtual ? (
            <CheckInTakeOverVirtualAction
              braindate={braindate}
              onClick={handleDismiss}
            />
          ) : (
            <CheckInTakeOverOnsiteAction
              braindate={braindate}
              onClick={handleDismiss}
            />
          )}
        </div>
      </div>
    </TakeOver>
  );
};

export default React.memo<Props>(CheckInTakeOverDumb);
